import * as ghl from "./ghl";

const ReqMethods = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

const ResponseStatus = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500,
};

const Environment = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
};

// Mirrors backend/src/_enums/user.js. The super admin's team: admins manage
// the team, members do everything else, viewers can look but not change.
const Roles = {
  AGENCY: "agency",
  ADMIN: "admin",
  MEMBER: "member",
  VIEWER: "viewer",
};

const TeamRoles = [Roles.ADMIN, Roles.MEMBER, Roles.VIEWER];

export { Environment, ReqMethods, ResponseStatus, Roles, TeamRoles, ghl };
